/**
 * Leitura de mapa indexado por string que vem do JSON do histórico (ação, campo, troca…).
 * `mapa['constructor']` / `['toString']` / `['__proto__']` achariam coisa do Object.prototype; aqui só vale chave PRÓPRIA.
 */
export function lerMapa<T>(mapa: Record<string, T>, chave: unknown): T | undefined {
  return typeof chave === 'string' && Object.prototype.hasOwnProperty.call(mapa, chave) ? mapa[chave] : undefined;
}
